exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-a0691bf6] {\n  text-align: justify;\n  padding-bottom: 25px;\n}\n.container[data-v-a0691bf6] {\n  text-align: left;\n  padding-bottom: 100px;\n}\n.columns[data-v-a0691bf6] {\n    text-align: justify;\n    -webkit-column-count: 2; /* Chrome, Safari, Opera */\n    -moz-column-count: 2; /* Firefox */\n    column-count: 2;\n    -webkit-column-gap: 40px; /* Chrome, Safari, Opera */\n    -moz-column-gap: 40px; /* Firefox */\n    column-gap: 40px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a0691bf6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ConditionsUtilisation.vue
// module id = 167
// module chunks = 1